import { render, staticRenderFns } from "./UploadMediaAssets.vue?vue&type=template&id=0f06e9fe&"
import script from "./UploadMediaAssets.vue?vue&type=script&lang=js&"
export * from "./UploadMediaAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports